import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import type { HttpBackendOptions } from 'i18next-http-backend'

const DEFAULT_LOCALE = 'en-US'

export async function init() {
  const instance = i18n.use(Backend).use(LanguageDetector).use(initReactI18next)

  // HMR in development
  if (import.meta.env.DEV) {
    const { HMRPlugin } = await import('i18next-hmr/plugin')
    instance.use(
      new HMRPlugin({
        vite: {
          client: true,
        },
      }),
    )
  }

  await instance.init<HttpBackendOptions>({
    react: {
      useSuspense: true,
    },
    ns: ['common'],
    keySeparator: '.',
    nsSeparator: ':',
    defaultNS: 'common',
    supportedLngs: ['en-US', 'es-ES'],
    fallbackLng: DEFAULT_LOCALE,
    initAsync: true,
    load: 'currentOnly',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      lookupCookie: 'i18nextLng',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      htmlTag:
        typeof document !== 'undefined' ? document.documentElement : undefined,
    },
  })

  return instance
}

export default i18n
